import type { FC } from "react";

import { SUB_CATEGORY_DELIMITER } from "app/common/services/categoryService";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import {
    ChildCategoryCellContainer,
    Ellipsis,
    Link,
    ParentCategory,
    ParentCategoryContainer,
    PAREN_CATEGORY_CONTAINER_CLASS,
    CHANGE_COLOR_ON_HOVER,
} from "app/components/React/Table/cells/category-cell/styled";

interface IChildCategoryCell {
    category: IFlattenedCategory;
    href?: string;
}

export const ChildCategoryCell: FC<IChildCategoryCell> = (props) => {
    const { category, href } = props;
    const { parentItem, text } = category;

    const content = (
        <ChildCategoryCellContainer>
            <Ellipsis className={CHANGE_COLOR_ON_HOVER}>{text}</Ellipsis>
            <ParentCategoryContainer className={PAREN_CATEGORY_CONTAINER_CLASS}>
                <ParentCategory>{SUB_CATEGORY_DELIMITER}</ParentCategory>
                <ParentCategory>{parentItem?.text}</ParentCategory>
            </ParentCategoryContainer>
        </ChildCategoryCellContainer>
    );
    return href ? <Link href={href}>{content}</Link> : content;
};
